export { default } from './integerPropType';
export * from './integerPropType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/integerPropType/index.js
// module id = 79
// module chunks = 25